module.exports = __webpack_public_path__ + "img/1w.d722ae20.svg";